<template>
  <div>
    <b-card
      class="card-transaction"
      no-body
    >
      <b-card-header>
        <b-card-title>Wallet Settings</b-card-title>
        <div
          v-if="$can('write', 'driver-wallet-settings')"
          style="cursor:pointer"
          class="d-flex align-items-center"
          @click="$emit('show-edit-section')"
        >
          <feather-icon icon="EditIcon" />
          Edit
        </div>
      </b-card-header>

      <b-card-body>
        <div
          v-for="item in walletData"
          :key="item.mode"
          class="transaction-item"
        >
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                rounded
                size="42"
                :variant="item.avatarVariant"
              >
                <feather-icon
                  size="18"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="align-self-center">
              <h6 class="transaction-title">
                {{ item.title }}
              </h6>
            </b-media-body>
          </b-media>
          <div
            class="font-weight-bolder"
            :class="item.textVariant ? 'text-danger':'text-success'"
          >
            {{ item.text }}
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BMediaBody, BMedia, BMediaAside, BAvatar,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,
    BAvatar,
  },
  props: {
    driverWallet: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const walletData = [
      {
        title: 'Block Threshold',
        icon: 'DivideIcon',
        avatarVariant: 'light-danger',
        text: `${props.driverWallet.blockThreshold} JOD`,
        textVariant: true,
      },
      {
        title: 'Apply Zone Commission',
        icon: 'CheckIcon',
        avatarVariant: props.driverWallet.applyZoneCommission ? 'light-success' : 'light-danger',
        text: props.driverWallet.applyZoneCommission ? 'Yes' : 'No',
        // eslint-disable-next-line no-unneeded-ternary
        textVariant: !props.driverWallet.applyZoneCommission,
      },
      {
        title: 'Override Commission Amount',
        icon: 'Edit3Icon',
        avatarVariant: 'light-success',
        text: `${props.driverWallet.overrideCommissionAmount} JOD`,
      },
    ]
    return {
      walletData,
    }
  },
}
</script>
